const STATUS = { running: "En cours", done: "Terminé", error: "Erreur" };

export const RecycleJobs = ({ jobs }) => (
  <div className="agent-table-wrap">
    <table className="agent-table" data-testid="recycle-jobs-table">
      <thead><tr><th>Date</th><th>Titre</th><th>Lignes</th><th>Listes</th><th>Statut</th><th>Listes créées</th></tr></thead>
      <tbody>
        {jobs.length === 0 && <tr><td colSpan={6} className="agent-name-cell">Aucun envoi pour l'instant.</td></tr>}
        {jobs.map((j) => (
          <tr key={j.id} data-testid={`recycle-job-${j.id}`}>
            <td>{new Date(j.created_at).toLocaleString("fr-FR")}</td>
            <td className="agent-name-cell">{j.title}</td>
            <td>{(j.sent_rows || 0).toLocaleString("fr-FR")} / {j.total_rows.toLocaleString("fr-FR")}</td>
            <td>{j.lists.length} / {j.total_lists}</td>
            <td data-testid={`recycle-job-status-${j.id}`}>{STATUS[j.status] || j.status}{j.error ? ` : ${j.error}` : ""}</td>
            <td className="agent-name-cell">
              {j.lists.filter((l) => l.status === "ok").map((l) => (
                <a key={l.title} href={l.url || undefined} target="_blank" rel="noreferrer" className="rc-joblink">{l.title}</a>
              ))}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
